function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSidepanelSettings = function SvgSidepanelSettings(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 40.069798,
    height: 37.991028,
    overflow: "hidden",
    ref: svgRef
  }, props), React.createElement("g", {
    style: {
      display: "inline"
    },
    transform: "translate(-4.450261,1.842851)"
  }, React.createElement("path", {
    className: "icon-tertiary",
    style: {
      fill: "#ffffff",
      strokeWidth: 0.999994,
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    fillRule: "evenodd",
    fill: "#ffffff",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.666667,
    stroke: "#002060",
    d: "m 15.877366,4.305324 3.863632,-1.5501 1.434882,-4.098078 h 4.635635 l 1.324855,4.319143 3.973659,1.440008 3.863631,-1.772046 3.200754,3.212054 -1.986831,3.654185 1.544912,4.098078 4.194619,1.440008 v 4.430118 l -4.083689,1.440007 -1.655842,3.765159 2.20779,4.098078 L 34.86273,31.993112 31,30 27.13637,31.661074 25.701486,35.648178 H 21.065851 L 19.630968,31.550101 16.098326,30.110973 12.014642,31.883019 8.923918,28.781938 10.57976,24.572887 9.254906,21.028793 4.950258,19.478694 V 15.159549 L 9.033947,13.608568 10.57976,9.732437 8.59293,5.634359 11.793683,2.422305 Z"
  })), React.createElement("g", {
    style: {
      display: "inline"
    },
    transform: "translate(-4.450261,1.842851)"
  }), React.createElement("g", {
    style: {
      display: "inline"
    },
    transform: "translate(-4.450261,1.842851)"
  }), React.createElement("g", {
    style: {
      display: "inline"
    },
    transform: "translate(-4.450261,1.842851)"
  }), React.createElement("g", {
    style: {
      display: "inline"
    },
    transform: "translate(-4.450261,1.842851)"
  }), React.createElement("g", {
    style: {
      display: "inline"
    },
    transform: "translate(-4.450261,1.842851)"
  }, React.createElement("path", {
    d: "M 12.454862,16.027899 C 12.94811,10.20405 17.672016,5.7359284 23.335207,5.7359284 v 4.9472766 c -3.102529,0 -5.689262,2.515565 -5.952797,5.790027 z",
    stroke: "#002060",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#adb9ca",
    fillRule: "evenodd",
    style: {
      display: "inline",
      stroke: "none",
      strokeWidth: 0.999999,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), React.createElement("path", {
    className: "icon-tertiary",
    style: {
      display: "inline",
      fill: "none",
      strokeWidth: 0.999999,
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    fillRule: "evenodd",
    fill: "#adb9ca",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.666667,
    stroke: "#002060",
    d: "M 12.454862,16.027899 C 12.94811,10.20405 17.672016,5.7359281 23.335207,5.7359281 v 4.9472769 c -3.102529,0 -5.689262,2.515564 -5.952797,5.790026 z"
  }), React.createElement("path", {
    d: "m 24.8072,4.3266486 v 1.536115 l 1.78274,0.3304762 c 4.462484,1.2725797 7.667187,5.3482172 7.667187,10.1122882 h -4.803531 c 0,-2.233709 -1.288082,-4.190494 -3.193428,-5.142463 L 24.8072,10.75226 v 1.643925 L 20.164328,8.3614168 Z",
    stroke: "#002060",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#adb9ca",
    fillRule: "evenodd",
    style: {
      display: "inline",
      stroke: "none",
      strokeWidth: 0.999999,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), React.createElement("path", {
    className: "icon-tertiary",
    style: {
      display: "inline",
      fill: "none",
      strokeWidth: 0.999999,
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    fillRule: "evenodd",
    fill: "#adb9ca",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.666667,
    stroke: "#002060",
    d: "m 24.548716,4.272333 v 1.536115 l 1.78274,0.3304762 c 4.462485,1.2725798 7.667187,5.3482168 7.667187,10.1122878 h -4.803531 c 0,-2.233709 -1.288082,-4.190494 -3.193428,-5.142462 l -1.452968,-0.410805 v 1.643924 L 19.905844,8.3071013 Z"
  }), React.createElement("path", {
    d: "m 39.144867,4.3266487 v 1.536256 l -1.871629,0.3301942 c -4.68544,1.2723684 -8.050589,5.3481331 -8.050589,10.1124291 h 5.043813 c 0,-2.233779 1.352416,-4.190853 3.352782,-5.142723 l 1.525623,-0.410827 v 1.644172 l 4.875221,-4.034733 z",
    stroke: "#002060",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#ecaec6",
    fillRule: "evenodd",
    style: {
      display: "inline",
      stroke: "none",
      strokeWidth: 0.999999,
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    className: "icon-primary"
  }), React.createElement("path", {
    className: "icon-tertiary",
    style: {
      display: "inline",
      fill: "none",
      strokeWidth: 0.999999,
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    fillRule: "evenodd",
    fill: "#ecaec6",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.666667,
    stroke: "#002060",
    d: "m 39.144867,4.3266486 v 1.536256 l -1.871629,0.3301942 c -4.68544,1.2723684 -8.050589,5.3481332 -8.050589,10.1124292 h 5.043813 c 0,-2.233779 1.352416,-4.190853 3.352782,-5.142723 l 1.525623,-0.410827 v 1.644172 l 4.875221,-4.0347331 z"
  }), React.createElement("path", {
    d: "m 36.371046,17.657731 h -1.626309 l -0.350205,1.871524 c -1.347272,4.685151 -5.662487,8.050511 -10.707004,8.050511 v -5.043812 c 2.365476,0 4.437117,-1.352204 5.445457,-3.352677 l 0.434763,-1.525546 h -1.741165 l 4.272231,-4.875404 z",
    stroke: "#002060",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#adb9ca",
    fillRule: "evenodd",
    style: {
      display: "inline",
      stroke: "none",
      strokeWidth: 0.999999,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), React.createElement("path", {
    className: "icon-tertiary",
    style: {
      display: "inline",
      fill: "none",
      strokeWidth: 0.999999,
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    fillRule: "evenodd",
    fill: "#adb9ca",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.666667,
    stroke: "#002060",
    d: "m 36.371046,17.657731 h -1.626309 l -0.350205,1.871524 c -1.347272,4.685151 -5.662487,8.050511 -10.707004,8.050511 v -5.043812 c 2.365476,0 4.437117,-1.352204 5.445457,-3.352677 l 0.434763,-1.525546 h -1.741165 l 4.272231,-4.875404 z"
  }), React.createElement("path", {
    d: "m 22.335323,29.693687 v -1.62631 L 20.4638,27.717171 C 15.778648,26.370605 12.413288,22.054685 12.413288,17.010167 h 5.043813 c 0,2.365477 1.352204,4.437118 3.352677,5.445458 l 1.525545,0.434763 v -1.740461 l 4.875404,4.271527 z",
    stroke: "#002060",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#adb9ca",
    fillRule: "evenodd",
    style: {
      display: "inline",
      stroke: "none",
      strokeWidth: 0.999999,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), React.createElement("path", {
    className: "icon-tertiary",
    style: {
      display: "inline",
      fill: "none",
      strokeWidth: 0.999999,
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    fillRule: "evenodd",
    fill: "#adb9ca",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.666667,
    stroke: "#002060",
    d: "m 22.335323,29.693687 v -1.62631 L 20.4638,27.717171 C 15.778648,26.370605 12.413288,22.054685 12.413288,17.010167 h 5.043813 c 0,2.365477 1.352204,4.437118 3.352677,5.445458 l 1.525545,0.434763 v -1.740461 l 4.875404,4.271527 z"
  }), React.createElement("path", {
    d: "m 19.459688,15.658147 h -1.626591 l -0.349642,-1.87163 C 16.136183,9.1010776 11.820721,5.7359287 6.7761695,5.7359287 v 5.0438123 c 2.3651733,0 4.4373775,1.352416 5.4452385,3.352783 l 0.434995,1.525623 h -1.74089 l 4.272084,4.87522 z",
    stroke: "#002060",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#ecaec6",
    fillRule: "evenodd",
    style: {
      stroke: "none",
      strokeWidth: 0.999999,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      fillOpacity: 1
    },
    className: "icon-secondary"
  }), React.createElement("path", {
    className: "icon-tertiary",
    style: {
      fill: "none",
      strokeWidth: 0.999999,
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    fillRule: "evenodd",
    fill: "#ecaec6",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.666667,
    stroke: "#002060",
    d: "m 19.459688,15.658147 h -1.626591 l -0.349642,-1.87163 C 16.136183,9.1010776 11.820721,5.7359287 6.7761695,5.7359287 v 5.0438123 c 2.3651733,0 4.4373775,1.352416 5.4452385,3.352783 l 0.434995,1.525623 h -1.74089 l 4.272084,4.87522 z"
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSidepanelSettings, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sidepanel-settings.0298dce2.svg";
export { ForwardRef as ReactComponent };